import React from 'react';
import { RouteObject, useRoutes } from 'react-router-dom';
import AppContainer from "../components/features/AppContainer/AppContainer";
import CheckoutPage from "../pages/Checkout/Checkout";

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <AppContainer />
  },
  {
    path: '/app',
    element: <AppContainer />
  },
  {
    path: '/activation/:activateCode',
    element: <AppContainer />
  },
  {
    path: '/pricing',
    element: <AppContainer />
  },
  {
    path: '/contact',
    element: <AppContainer />
  },
  {
    path: '/features',
    element: <AppContainer />
  },
  {
    path: '/getstarted',
    element: <AppContainer />
  },
  {
    path: '/api',
    element: <AppContainer />
  },
  {
    path: '/notifications',
    element: <AppContainer />
  },
  {
    path: '/checkout',
    element: <CheckoutPage />
  },
  {
    path: '/checkout/paymentfailure',
    element: <CheckoutPage />
  },
  {
    path: '/paymentsuccess',
    element: <AppContainer />
  },
  {
    path: '/metadata',
    element: <AppContainer />
  },
  {
    path: '/metadata/:datasetID',
    element: <AppContainer />
  }
];

export const AppRoutes: React.FC = () => {
  const routeElements = useRoutes(routes);
  return routeElements;
};
